import { Button, Checkbox, Group, Table, Text, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";
import { useEffect, useState } from "react";
import CollapsibleHeader from "../../components/CollapsibleHeader";
import { IconKey, IconSearch } from "@tabler/icons-react";
import IGroup from "../../interfaces/IGroup";
import BasePage from "../BasePage";
import { coreApi } from "../../utils/CoreAPI";

interface GroupListProps {
    items: IGroup[];
    selectedGroups: string[];
    setSelectedGroups: React.Dispatch<React.SetStateAction<string[]>>;
}

function GroupList({ items, selectedGroups, setSelectedGroups }: GroupListProps) {
    const toggleCheckbox = (groupName: string) => {
        setSelectedGroups(prev => prev.includes(groupName) ? prev.filter(selectedGroup => selectedGroup !== groupName) : [...prev, groupName]);
    };

    return (
        <>
            {items.length === 0 ? <Text>No groups selected</Text> :
                <Table withRowBorders>
                    <Table.Thead>
                        <Table.Tr>
                            <Table.Td>
                            </Table.Td>
                            <Table.Td>
                                <Text>Display Name</Text>
                            </Table.Td>
                            <Table.Td>
                                <Text>Mail Address</Text>
                            </Table.Td>
                        </Table.Tr>
                    </Table.Thead>
                    <Table.Tbody>
                        {items.map((item, key) =>
                            <Table.Tr key={key}>
                                <Table.Td>
                                    <Checkbox checked={selectedGroups.includes(item.displayName)} onChange={() => toggleCheckbox(item.displayName)} />
                                </Table.Td>
                                <Table.Td>
                                    <Text>{item.displayName}</Text>
                                </Table.Td>
                                <Table.Td>
                                    <Text>{item.mail}</Text>
                                </Table.Td>
                            </Table.Tr>
                        )}
                    </Table.Tbody>
                </Table>
            }
        </>
    )
}

function AddUserPage() {
    const [isServiceAccount, setIsServiceAccount] = useState(false);
    const [accountEnabled, setAccountEnabled] = useState(true);

    // Group list declarations
    const [availableGroups, setAvailableGroups] = useState<IGroup[]>([]);
    const [filteredGroups, setFilteredGroups] = useState<IGroup[]>([]);
    const [selectedGroups, setSelectedGroups] = useState<string[]>([]);

    const getAvailableGroups = async () => {
        // setLoading(true);

        // const result = await fetchGraphDataset("/groups");
        // const groupData: IGroup[] = result
        //     .filter((group: any) => group.securityEnabled !== true)
        //     .map((group: any) => ({
        //         displayName: group.displayName,
        //         mail: group.mail,
        //         securityEnabled: group.securityEnabled
        //     }))
        //     .sort((a, b) => a.displayName.localeCompare(b.displayName));

        // setAvailableGroups(groupData.sort());
        // setFilteredGroups(groupData.sort());

        // setLoading(false);
    };

    const filterGroups = async (query: string) => {
        setFilteredGroups(availableGroups.filter(group => group.displayName.toLowerCase().includes(query.toLowerCase())));
    };

    const form = useForm({
        mode: 'controlled',
        initialValues: {
            firstName: '',
            lastName: '',
            displayName: '',
            email: '',
            personalEmail: '',
            accountEnabled: true,
            password: '',
            jobTitle: '',
        },

        // validate: {
        //     firstName: (value) => (value.length < 1 ? 'First name must have at least 1 letter' : null),
        //     lastName: (value) => (value.length < 1 ? 'Last name must have at least 1 letter' : null),
        //     email: (value) => (/^\S+@\S+$/.test(value) ? null : 'Invalid email'),
        //     personalEmail: (value) => (/^\S+@\S+$/.test(value) ? null : 'Invalid email'),
        //     jobTitle: (value) => (value.length < 1 ? 'Job title must have at least 1 letter' : null),
        // },
    });

    const generateEmail = (fName: string, lName: string, country: string) => {
        if (fName !== "" && lName !== "") {
            let fChar: string = fName.charAt(0);

            fChar = fChar.toLowerCase();
            lName = lName.toLowerCase().replace(/\s/g, '');

            switch (country) {
                case "Canada":
                    return fChar + "." + lName + "@experiorheadoffice.ca"
                case "US":
                    return fChar + "." + lName + "@experiorheadoffice.com"
                default:
                    return ""
            }
        } else {
            return ""
        }
    }

    const generatePassword = async () => {
        const response = await coreApi.get("/users/generate-password");
        form.setFieldValue('password', response.data['password']);
    };

    const submitForm = async (e: { preventDefault: () => void; }) => {
        e.preventDefault();

        console.log(form.getValues());

        const jsonData = {
            "accountEnabled": form.getValues().accountEnabled,
            "givenName": form.getValues().firstName,
            "surname": form.getValues().lastName,
            "displayName": form.getValues().displayName,
            "userPrincipalName": form.getValues().email,
            "mailNickname": form.getValues().firstName + form.getValues().lastName,
            "jobTitle": form.getValues().jobTitle,
            "preferredLanguage": "en-US",
            "passwordProfile": {
                "forceChangePasswordNextSignIn": true,
                "password": form.getValues().password
            }
        }

        // graphApi().then((axios) => {
        //     axios.post("/users", JSON.stringify(jsonData));
        // });
    };

    useEffect(() => {
        getAvailableGroups();
        generatePassword();
    }, []);

    return (
        <BasePage title="Add User">
            <form onSubmit={submitForm}>
                <CollapsibleHeader header="Account Settings" defaultState={true}>
                    <Checkbox
                        my={"sm"}
                        label="Service Account"
                        checked={isServiceAccount}
                        onChange={(event) => {
                            setIsServiceAccount(event.currentTarget.checked);
                            form.setFieldValue('personalEmail', 'support@experiorheadoffice.ca');
                            form.setFieldValue('jobTitle', 'Service Account')
                        }}
                    />
                    <Checkbox my={"sm"} checked={accountEnabled} label="Account Enabled" onChange={(event) => setAccountEnabled(event.currentTarget.checked)} />
                    {accountEnabled ? null : <Text c={"red"} size="12px">The user will not be able to sign in if the account is disabled.</Text>}
                    <TextInput my={"sm"}
                        required
                        type="email"
                        label="Personal Email"
                        placeholder="janedoe@gmail.com"
                        description="This will be used to send the user their temporary login details."
                        key={form.key('personalEmail')}
                        {...form.getInputProps('personalEmail')}
                        disabled={isServiceAccount}
                    />
                    <TextInput my={"sm"}
                        required
                        readOnly
                        type="text"
                        label="Password"
                        placeholder="Password"
                        key={form.key('password')}
                        {...form.getInputProps('password')}
                    />

                    <Button leftSection={<IconKey size={18} />} onClick={() => generatePassword()}>Generate Password</Button>
                </CollapsibleHeader>

                <CollapsibleHeader header="Basic Information" >
                    <TextInput my={"sm"} required label="Job Title" placeholder="Commissions Administrator" key={form.key('jobTitle')} {...form.getInputProps('jobTitle')} disabled={isServiceAccount} />

                    <Group justify="center" grow>
                        <TextInput
                            my={"sm"}
                            required
                            label="First Name"
                            placeholder="Jane"
                            key={form.key('firstName')}
                            {...form.getInputProps('firstName')}
                            onBlur={(event) => {
                                form.setFieldValue('displayName', form.getValues().displayName + event.currentTarget.value);
                            }}
                        />
                        <TextInput
                            my={"sm"}
                            required
                            label="Last Name"
                            placeholder="Doe"
                            key={form.key('lastName')}
                            {...form.getInputProps('lastName')}
                            onBlur={(event) => {
                                form.setFieldValue('displayName', form.getValues().displayName + " " + event.currentTarget.value);
                                form.setFieldValue('email', generateEmail(form.getValues().firstName, form.getValues().lastName, "Canada"));
                            }}
                        />
                    </Group>

                    <TextInput my={"sm"} disabled label="Display Name" key={form.key('displayName')} {...form.getInputProps('displayName')} />
                    <TextInput my={"sm"} required type="email" label="Email" placeholder="j.doe@experiorheadoffice.ca" key={form.key('email')} {...form.getInputProps('email')} />
                </CollapsibleHeader>

                <CollapsibleHeader header="Groups">
                    <TextInput
                        my={"sm"}
                        placeholder="type to start searching..."
                        leftSection={<IconSearch size={18} />}
                        onChange={(event) => {
                            var query: string = event.currentTarget.value;

                            filterGroups(query);
                        }}
                    />
                    <Button onClick={() => console.log(selectedGroups)}>Click</Button>
                    <GroupList items={filteredGroups} selectedGroups={selectedGroups} setSelectedGroups={setSelectedGroups} />
                </CollapsibleHeader>

                {/* <CollapsibleHeader header="Shared Mailboxes">
                    <Text>Empty for now...</Text>
                </CollapsibleHeader> */}

                <Button my={"sm"} type="submit" w={150}>Add User</Button>
            </form>
        </BasePage>
    )
}

export default AddUserPage